<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input
          v-model="keywords"
          placeholder="请输入姓名、医院"
          class="handle-input mr10"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >搜索</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportdoctorlist"
          >导出医生审核列表</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column label="审核状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.audit_type == 1">正在审核</el-tag>
            <el-tag v-else-if="scope.row.audit_type == 2">审核通过</el-tag>
            <el-tag v-else-if="scope.row.audit_type == 3">审核被拒</el-tag>
            <el-tag v-else>未提交审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="职称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="department"
          label="科室"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="hospital"
          label="所属医院"
          align="center"
        ></el-table-column>
        <el-table-column label="申请日期" align="center">
          <template slot-scope="scope">{{
            formatDate(scope.row.updated_at)
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(false, scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="scope.row.audit_type == 1"
              type="text"
              @click="handleEdit(true, scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="姓名：" v-show="!form_show.name">
          <span class="fc mr10">{{ form.name }}</span>
          <el-button type="primary" class="mr10" @click="handleToFixed('name')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="姓名：" v-show="form_show.name">
          <el-input
            v-model="form_change.name"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('name')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('name')"
            >取消</el-button
          >
        </el-form-item>
        <el-form-item label="头像：" v-show="!form_show.avatar">
          <el-image
            class="look-thumb"
            :src="form.avatar"
            :preview-src-list="[form.avatar]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('avatar')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="头像：" v-show="form_show.avatar">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.avatar"
              :src="form.avatar"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!form.avatar && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('avatar')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item label="手机号：">
          <span class="fc">{{ form.phone }}</span>
        </el-form-item>
        <el-form-item label="性别：" v-show="!form_show.sex">
          <span class="fc mr10">{{ getSexType(form.sex) }}</span>
          <el-button type="primary" class="mr10" @click="handleToFixed('sex')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="性别：" v-show="form_show.sex">
          <el-select v-model="doctor_sex_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in window_sex_types"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('sex')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('sex')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="职称：" v-show="!form_show.title_id">
          <span class="fc mr10">{{ getTitleName(form.title_id) }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('title_id')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="职称：" v-show="form_show.title_id">
          <el-select v-model="doctor_title_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in title_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('title_id')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('title_id')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="科室：" v-show="!form_show.department_id">
          <span class="fc mr10">{{
            getDepartmentName(form.department_id)
          }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('department_id')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="科室：" v-show="form_show.department_id">
          <el-select v-model="doctor_department_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in department_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('department_id')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('department_id')"
            >取消</el-button
          >
        </el-form-item>
        <el-form-item label="所属医院：" v-show="!form_show.hospital">
          <span class="fc mr10">{{ form.hospital }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('hospital')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="所属医院：" v-show="form_show.hospital">
          <el-input
            v-model="form_change.hospital"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('hospital')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('hospital')"
            >取消</el-button
          >
        </el-form-item>
        <el-form-item
          label="医生职称证书："
          v-show="!form_show.title_certificate_url"
        >
          <el-image
            class="look-thumb"
            :src="form.title_certificate_url"
            :preview-src-list="[form.title_certificate_url]"
            alt="暂未上传"
          >
            <div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div>
          </el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('title_certificate_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医生职称证书："
          v-show="form_show.title_certificate_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeTitleUpload"
          >
            <img
              v-if="form.title_certificate_url"
              :src="form.title_certificate_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.title_certificate_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('title_certificate_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item label="身份证正面：" v-show="!form_show.id_front_url">
          <el-image
            class="look-thumb"
            :src="form.id_front_url"
            :preview-src-list="[form.id_front_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('id_front_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="身份证正面：" v-show="form_show.id_front_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeidfrontPhotoUpload"
          >
            <img
              v-if="form.id_front_url"
              :src="form.id_front_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.id_front_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('id_front_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item label="身份证反面：" v-show="!form_show.id_back_url">
          <el-image
            class="look-thumb"
            :src="form.id_back_url"
            :preview-src-list="[form.id_back_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('id_back_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="身份证反面：" v-show="form_show.id_back_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeidbackPhotoUpload"
          >
            <img
              v-if="form.id_back_url"
              :src="form.id_back_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.id_back_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('id_back_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证信息页："
          v-show="!form_show.doctor_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_certificate_info_url"
            :preview-src-list="[form.doctor_certificate_info_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_certificate_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证信息页："
          v-show="form_show.doctor_certificate_info_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforecertificateUpload"
          >
            <img
              v-if="form.doctor_certificate_info_url"
              :src="form.doctor_certificate_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.doctor_certificate_info_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_certificate_info_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证照片页："
          v-show="!form_show.doctor_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_certificate_photo_url"
            :preview-src-list="[form.doctor_certificate_photo_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_certificate_photo_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证照片页："
          v-show="form_show.doctor_certificate_photo_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforecertificatePhotoUpload"
          >
            <img
              v-if="form.doctor_certificate_photo_url"
              :src="form.doctor_certificate_photo_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.doctor_certificate_photo_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_certificate_photo_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书照片页："
          v-show="!form_show.doctor_practice_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_practice_certificate_photo_url"
            :preview-src-list="[form.doctor_practice_certificate_photo_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_practice_certificate_photo_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书照片页："
          v-show="form_show.doctor_practice_certificate_photo_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforePracticePhotoUpload"
          >
            <img
              v-if="form.doctor_practice_certificate_photo_url"
              :src="form.doctor_practice_certificate_photo_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.doctor_practice_certificate_photo_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_practice_certificate_photo_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书信息页："
          v-show="!form_show.doctor_practice_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_practice_certificate_info_url"
            :preview-src-list="[form.doctor_practice_certificate_info_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_practice_certificate_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书信息页："
          v-show="form_show.doctor_practice_certificate_info_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforePracticeInfoUpload"
          >
            <img
              v-if="form.doctor_practice_certificate_info_url"
              :src="form.doctor_practice_certificate_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.doctor_practice_certificate_info_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_practice_certificate_info_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item label="卫健委信息截图：" v-show="!form_show.NHC_info_url">
          <el-image
            class="look-thumb"
            :src="form.NHC_info_url"
            :preview-src-list="[form.NHC_info_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('NHC_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="卫健委信息截图：" v-show="form_show.NHC_info_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeNHCInfoUpload"
          >
            <img
              v-if="form.NHC_info_url"
              :src="form.NHC_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!form.NHC_info_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('NHC_info_url')"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item label="被拒说明：" v-if="form.audit_type == 3">
          <span class="fc">{{ form.remark }}</span>
        </el-form-item>

        <el-form-item label="状态：" prop="status" v-if="is_review">
          <el-select
            v-model="form.status"
            class="handle-select"
            @change="statusChange"
          >
            <el-option
              v-for="(child, index) in status_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="拒绝说明："
          prop="remark"
          v-show="is_review && remark_show"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="form.remark"
            @input="onInput()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')" v-if="is_review"
          >提 交</el-button
        >
        <el-button type="primary" @click="closeEdit(true)" v-else
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <!-- 详情弹出框 -->
    <el-dialog
      :visible.sync="detailVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" label-width="160px">
        <el-form-item label="姓名：" v-show="!form_show.name">
          <span class="fc mr10">{{ form.name }}</span>
        </el-form-item>
        <el-form-item label="头像：" v-show="!form_show.avatar">
          <el-image
            class="look-thumb"
            :src="form.avatar"
            :preview-src-list="[form.avatar]"
          ></el-image>
        </el-form-item>
        <el-form-item label="手机号：">
          <span class="fc">{{ form.phone }}</span>
        </el-form-item>
        <el-form-item label="性别：" v-show="!form_show.sex">
          <span class="fc mr10">{{ getSexType(form.sex) }}</span>
        </el-form-item>
        <el-form-item label="职称：" v-show="!form_show.title_id">
          <span class="fc mr10">{{ getTitleName(form.title_id) }}</span>
        </el-form-item>
        <el-form-item label="科室：" v-show="!form_show.department_id">
          <span class="fc mr10">{{
            getDepartmentName(form.department_id)
          }}</span>
        </el-form-item>
        <el-form-item label="所属医院：" v-show="!form_show.hospital">
          <span class="fc mr10">{{ form.hospital }}</span>
        </el-form-item>
        <el-form-item
          label="医生职称证书："
          v-show="!form_show.title_certificate_url"
        >
          <el-image
            class="look-thumb"
            :src="form.title_certificate_url"
            :preview-src-list="[form.title_certificate_url]"
            alt="暂未上传"
          >
            <div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="身份证正面：" v-show="!form_show.id_front_url">
          <el-image
            class="look-thumb"
            :src="form.id_front_url"
            :preview-src-list="[form.id_front_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item label="身份证反面：" v-show="!form_show.id_back_url">
          <el-image
            class="look-thumb"
            :src="form.id_back_url"
            :preview-src-list="[form.id_back_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item
          label="医师资格证信息页："
          v-show="!form_show.doctor_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_certificate_info_url"
            :preview-src-list="[form.doctor_certificate_info_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item
          label="医师资格证照片页："
          v-show="!form_show.doctor_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_certificate_photo_url"
            :preview-src-list="[form.doctor_certificate_photo_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书照片页："
          v-show="!form_show.doctor_practice_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_practice_certificate_photo_url"
            :preview-src-list="[form.doctor_practice_certificate_photo_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书信息页："
          v-show="!form_show.doctor_practice_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="form.doctor_practice_certificate_info_url"
            :preview-src-list="[form.doctor_practice_certificate_info_url]"
            alt="暂未上传"
            ><div slot="error" class="image-slot">
              <i>暂未上传</i>
            </div></el-image
          >
        </el-form-item>
        <el-form-item label="卫健委信息截图：" v-show="!form_show.NHC_info_url">
          <el-image
            class="look-thumb"
            :src="form.NHC_info_url"
            :preview-src-list="[form.NHC_info_url]"
          ></el-image>
        </el-form-item>
        <el-form-item label="被拒说明：" v-if="form.audit_type == 3">
          <span class="fc">{{ form.remark }}</span>
        </el-form-item>

        <el-form-item label="状态：" prop="status" v-if="is_review">
          <el-select
            v-model="form.status"
            class="handle-select"
            @change="statusChange"
          >
            <el-option
              v-for="(child, index) in status_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="拒绝说明："
          prop="remark"
          v-show="is_review && remark_show"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="form.remark"
            @input="onInput()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="closeEdit(false)">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/iapetusApiConfig";
import http2 from "../../../api/uploadApiConfig";
import http3 from "../../../api/hemeraApiConfig";
import VUE_APP_API_IAPETUS_URL from "../../../api/getapi/iapetus";
import $ from "jquery";
export default {
  name: "Doctorreviewlist",
  data() {
    return {
      uploading: false,
      select_doctor_id: "",
      select_user_ids: "",
      doctor_sex_id: "",
      doctor_title_id: "",
      title_ids: [],
      doctor_department_id: "",
      department_ids: [],
      window_sex_types: [
        { name: "男", id: 1 },
        { name: "女", id: 0 },
      ],
      status_types: [
        { label: "通过", value: 1 },
        { label: "拒绝", value: 2 },
      ],
      is_review: false,
      remark_show: false,
      msg_types: [
        { label: "运营消息", value: 1 },
        { label: "vip开通成功/到期提醒", value: 2 },
        {
          label: "问诊订单状态提醒（生成、支付成功、退款、订单完成）",
          value: 3,
        },
        {
          label: "药品订单提醒（生成、支付成功、发货、退单、订单完成）",
          value: 4,
        },
      ],
      excelData: [],
      excel_current: 1,
      excel_totals: 1,
      tableData: [],
      readerData: {},
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 0,
      keywords: "",
      loading: false,
      multipleSelection: [],
      delList: [],
      detailVisible: false,
      editVisible: false,
      is_add: false,
      form: {},
      form_show: {},
      form_change: {},
      submit_obj: {},
      rules: {
        remark: [
          { required: true, message: "请填写拒绝说明", trigger: "blur" },
        ],
      },
      idx: -1,
      id: -1,
    };
  },
  created() {
    let that = this;
    that.getData();
    http.get("/common/titles").then(function(res) {
      that.title_ids = res.data.data;
    });
    http.get("/common/departments").then(function(res) {
      that.department_ids = res.data.data;
    });
  },
  methods: {
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `user/` + that.select_user_ids + `/avatar`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.avatar_path =
              `user/` + that.select_user_ids + `/avatar/` + filename;
            that.form.avatar = URL.createObjectURL(file);
            that.putDoctor("avatar_path", that.form.avatar_path, false);
            that.$set(that.form_show, "avatar", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeTitleUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_professional`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.title_certificate_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_professional/` +
              filename;
            that.form.title_certificate_url = URL.createObjectURL(file);
            that.putDoctor(
              "title_certificate_path",
              that.form.title_certificate_path,
              false
            );
            that.$set(that.fixed_show, "title_certificate_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeidbackPhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.id_back_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.form.id_back_url = URL.createObjectURL(file);
            that.putDoctor("id_back_path", that.form.id_back_path, false);
            that.$set(that.fixed_show, "id_back_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeidfrontPhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.id_front_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.form.id_front_url = URL.createObjectURL(file);
            that.putDoctor("id_front_path", that.form.id_front_path, false);
            that.$set(that.fixed_show, "id_front_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforecertificateUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.doctor_certificate_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.form.doctor_certificate_info_url = URL.createObjectURL(file);
            that.putDoctor(
              "doctor_certificate_info_path",
              that.form.doctor_certificate_info_path,
              false
            );
            that.$set(that.fixed_show, "doctor_certificate_info_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforecertificatePhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.doctor_certificate_photo_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.form.doctor_certificate_photo_url = URL.createObjectURL(file);
            that.putDoctor(
              "doctor_certificate_photo_path",
              that.form.doctor_certificate_photo_path,
              false
            );
            that.$set(that.fixed_show, "doctor_certificate_photo_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforePracticePhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.doctor_practice_certificate_photo_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.form.doctor_practice_certificate_photo_url = URL.createObjectURL(
              file
            );
            that.putDoctor(
              "doctor_practice_certificate_photo_path",
              that.form.doctor_practice_certificate_photo_path,
              false
            );
            that.$set(
              that.fixed_show,
              "doctor_practice_certificate_photo_url",
              false
            );
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforePracticeInfoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_info`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.doctor_practice_certificate_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_info/` +
              filename;
            that.form.doctor_practice_certificate_info_url = URL.createObjectURL(
              file
            );
            that.putDoctor(
              "doctor_practice_certificate_info_path",
              that.form.doctor_practice_certificate_info_path,
              false
            );
            that.$set(
              that.fixed_show,
              "doctor_practice_certificate_info_url",
              false
            );
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeNHCInfoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_info`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.form.NHC_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_info/` +
              filename;
            that.form.NHC_info_url = URL.createObjectURL(file);
            that.putDoctor("NHC_info_path", that.form.NHC_info_path, false);
            that.$set(that.fixed_show, "NHC_info_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleFixedCancel(key) {
      this.$set(this.form_show, key, false);
      this.$forceUpdate();
    },
    handleToFixed(key) {
      let that = this;
      that.form_change = {};
      if (key == "sex") {
        that.doctor_sex_id = that.form[key];
      } else if (key == "title_id") {
        that.doctor_title_id = that.form[key];
      } else if (key == "department_id") {
        that.doctor_department_id = that.form[key];
      } else if (key == "is_sign") {
        that.doctor_sign_id = that.form[key];
      } else if (key == "is_recommend") {
        that.doctor_recommend_id = that.form[key];
      } else if (key == "service_type") {
        that.doctor_service_id = that.form["service_type"];
      } else if (key == "service_price") {
        that.doctor_service_price = that.form["service_price"];
      } else if (key == "area_json") {
        that.doctor_province = "";
        that.doctor_city = "";
        that.doctor_street = "";
        if (that.form["area_json"]) {
          let area = JSON.parse(that.form["area_json"]);
          that.doctor_province = area[0]["id"];
          that.doctor_city = area[1]["id"];
          that.doctor_street = area[2]["id"];
          if (that.doctor_province) {
            http3.get("/areas/" + that.doctor_province).then(function(res) {
              that.citys = res.data.data;
            });
          }
          if (that.doctor_province) {
            http3.get("/areas/" + that.doctor_city).then(function(res) {
              that.streets = res.data.data;
            });
          }
          if (area[1]["name"] == "市辖区") {
            that.city_show = false;
          } else {
            that.city_show = true;
          }
        }
      } else {
        that.form_change[key] = that.form[key];
      }
      that.$set(that.form_show, key, true);
      that.$forceUpdate();
    },
    handleFixedConfirm(key) {
      let that = this;
      if (key == "sex") {
        that.form[key] = that.doctor_sex_id;
      } else if (key == "title_id") {
        that.form[key] = that.doctor_title_id;
      } else if (key == "department_id") {
        that.form[key] = that.doctor_department_id;
      } else if (key == "is_sign") {
        that.form[key] = that.doctor_sign_id;
      } else if (key == "is_recommend") {
        that.form[key] = that.doctor_recommend_id;
      } else if (key == "service_type") {
        that.form["service_type"] = that.doctor_service_id;
      } else if (key == "service_price") {
        that.form["service_price"] = that.doctor_service_price;
      } else if (key == "area_json") {
        let area = [];
        let province_obj = _.filter(that.provinces, function(selector) {
          return selector.id === that.doctor_province;
        })[0];
        let city_obj = _.filter(that.citys, function(selector) {
          return selector.id === that.doctor_city;
        })[0];
        let street_obj = _.filter(that.streets, function(selector) {
          return selector.id === that.doctor_street;
        })[0];
        if (province_obj) {
          area.push(province_obj);
        }
        if (city_obj) {
          area.push(city_obj);
        }
        if (street_obj) {
          area.push(street_obj);
        }
        if (area.length > 0) {
          that.form["area_json"] = JSON.stringify(area);
        } else {
          that.form["area_json"] = "";
        }
      } else {
        that.form[key] = this.form_change[key];
      }
      that.$set(that.form_show, key, false);
      that.$forceUpdate();
      if (key == "name" || key == "hospital" || key == "is_recommend") {
        that.putDoctor(key, that.form[key], true);
      } else {
        that.putDoctor(key, that.form[key], false);
      }
    },
    putDoctor(key, value, init) {
      let that = this;
      let params = {};
      params[key] = value;
      if (key == "service_type") {
        params["service_price"] = that.form["service_price"];
      } else if (key == "service_price") {
        params["service_type"] = that.form["service_type"];
      } else if (key == "area_json") {
        params["area"] = that.getAreaName(value);
      }
      http
        .put("/admin/doctors/audit/" + that.select_doctor_id, params)
        .then(function(res) {
          if (res.data.status_code == 200) {
            if (init) {
              that.getData();
            }
          }
        });
    },
    getSexType(id) {
      if (id == 0) {
        return "女";
      } else if (id == 1) {
        return "男";
      } else {
        return "未知";
      }
    },
    getTitleName(id) {
      var item = _.filter(this.title_ids, function(selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getTitleId(name) {
      var item = _.filter(this.title_ids, function(selector) {
        return selector.name == name;
      })[0];
      if (item) {
        return item["id"];
      } else {
        return "";
      }
    },
    getDepartmentName(id) {
      var item = _.filter(this.department_ids, function(selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getDepartmentId(name) {
      var item = _.filter(this.department_ids, function(selector) {
        return selector.name == name;
      })[0];
      if (item) {
        return item["id"];
      } else {
        return "";
      }
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      http.get("/admin/doctors/audit", { params: params }).then(function(res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.items;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    // 导出医生列表 请求第一页
    exportdoctorlist() {
      let that = this;
      let params = {
        page: that.excel_current,
        page_size: 100,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      http.get("/admin/doctors", { params: params }).then(function(res) {
        that.excelData = res.data.data.items;
        that.excel_current = res.data.data.page;
        that.excel_totals = res.data.data.total_pages;
        if (that.excel_totals == 1) {
          that.exportdoctor(that.excelData);
        } else {
          that.exportdoctoralllist();
        }
      });
    },
    // 导出医生列表 请求剩余页
    exportdoctoralllist() {
      let that = this;
      let apiURL = "";
      that.excel_current = 2;
      if (process.env.NODE_ENV === "development") {
        apiURL = "http://proxy.jiankanghao.net:50206/api/v1";
      } else {
        apiURL = VUE_APP_API_IAPETUS_URL;
      }
      apiURL = apiURL + "/admin/doctors";
      for (let i = 2; i <= this.excel_totals; i++) {
        let params = {
          page: that.excel_current,
          page_size: 100,
        };
        if (that.keywords) {
          params["keywords"] = that.keywords;
        }
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function(data) {
            if (data.status_code == 200) {
              that.excelData = that.excelData.concat(data.data.items);
              that.excel_current += 1;
              that.excel_totals = data.data.total_pages;
            }
          },
          error: function(e) {
            console.log(e.responseText);
          },
        });
      }
      this.exportdoctor(that.excelData);
    },
    // 导出医生列表 导出方法
    exportdoctor(res) {
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = [
          "姓名",
          "手机号",
          "所属医院",
          "科室",
          "职称",
          "审核状态",
          "时间",
        ];
        const filterVal = [
          "name",
          "phone",
          "hospital",
          "department",
          "title",
          "audit_type",
          "updated_at",
        ];
        const list = res;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "医生审核列表");
        that.excelData = [];
        that.excel_current = 1;
        that.excel_totals = 1;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    // 删除操作
    handleDelete(index, row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/messages/" + row.id).then(function(res) {
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection() {},
    onInput() {
      this.$forceUpdate();
    },
    statusChange() {
      if (this.form.status == 2) {
        this.remark_show = true;
      } else {
        this.remark_show = false;
      }
    },
    // 编辑操作
    handleEdit(is_edit, row) {
      console.log(row, "row");
      let that = this;
      that.select_doctor_id = row.id;
      that.select_user_ids = row.user_id;
      that.form = {};
      (that.remark_show = false), (that.is_review = is_edit);
      http.get("/admin/doctors/audit/" + row.id).then(function(res) {
        that.form = res.data.data;
        that.form_show = {};
        that.form["title_id"] = that.getTitleId(that.form["title"]);
        that.form["department_id"] = that.getDepartmentId(
          that.form["department"]
        );
        if (that.is_review) {
          that.form["status"] = 1;
          that.form["remark"] = "";
        }
        for (let key in that.form) {
          that.form_show[key] = false;
        }
        if (is_edit == false) {
          that.detailVisible = true;
        } else {
          that.editVisible = true;
        }
      });
    },
    //新增操作
    addEdit() {
      this.form = {
        type: 1,
        platform_type: 1,
        message: "",
        extras: "",
        devices: "",
      };
      this.is_add = true;
      this.editVisible = true;
    },
    //关闭编辑框
    closeEdit(is_edit) {
      let that = this;
      if (is_edit == false) {
        that.detailVisible = false;
      } else {
        that.editVisible = false;
      }
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      if (that.form.status == 1) {
        that.form.remark = "remark";
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            status: that.form.status,
            remark: that.form.remark,
          };
          http
            .put("/admin/doctors/audit/" + that.form.id, params)
            .then(function(res) {
              if (res.data.status_code == 200) {
                that.getData();
              }
            });
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.ml10 {
  margin-top: 14px;
  position: relative;
  left: -10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.look-thumb {
  display: block;
  width: 178px;
  height: 178px;
}
.avatar {
  width: 178px;
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
